module.exports = "/_next/static/resources/man-2-4bf325eb44dcf7c9b035039d9a87e2fb.jpg";